import { createWebHistory } from "vue-router";
import JsdRouter from "./JSDindent.js";
import BlsRouter from "./BLSRouter.js";
import CCMRouter from "./CCMRouter.js";
import PublicRouter from "./PublicRouter.js";
export default {
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: () => import(/* @vite-ignore */ "../views/main/index.vue"),
      children: [
        // 个人信息
        {
          path: "/userInfo",
          meta: { alias: "/baseData-userInfo" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/userInfo/index.vue"),
        },
        // 页面配置
        {
          path: "/configuration",
          meta: { alias: "/baseData-configuration" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/configuration/index.vue"),
        },
        // 域名管理
        {
          path: "/domain",
          meta: { alias: "/baseData-domain" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/configuration/domain.vue"),
        },
        // 品控
        {
          path: "/quality-control",
          meta: { alias: "/quality-control" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/qualityControl/index.vue"),
        },
        {
          path: "/quality-control-list",
          meta: { alias: "/quality-control" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/qualityControlList/index.vue"
            ),
        },
        {
          path: "/quality-control-result",
          meta: {
            parentRouter: "/quality-control",
            alias: "/quality-control-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/qualityControl/result.vue"
            ),
        },

        // 配色
        {
          path: "/color-match",
          meta: { alias: "/color-match" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorMatch/index.vue"),
        },
        {
          path: "/color-match-table",
          meta: { parentRouter: "/color-match", alias: "/color-match-table" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorMatch/colorTable.vue"
            ),
        },

        // 修色
        {
          path: "/color-trim",
          meta: { alias: "/color-trim" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/index.vue"),
        },
        {
          path: "/color-trim-fast-form",
          meta: { parentRouter: "/color-trim", alias: "/color-trim-fast-form" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/fastForm.vue"),
        },
        {
          path: "/color-trim-form-result",
          meta: {
            parentRouter: "/color-trim",
            alias: "/color-trim-form-result",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/formResult.vue"),
        },
        {
          path: "/color-trim-form",
          meta: { parentRouter: "/color-trim", alias: "/color-trim-form" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/form.vue"),
        },
        {
          path: "/color-trim-result",
          meta: { parentRouter: "/color-trim", alias: "/color-trim-result" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/result.vue"),
        },
        {
          path: "/color-trim-adjustment",
          meta: {
            parentRouter: "/color-trim",
            alias: "/color-trim-adjustment",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/adjustment.vue"),
        },

        // 单纤维微调
        {
          path: "/oneAdjustment",
          meta: { alias: "/oneAdjustment" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/oneAdjustment/index.vue"
            ),
        },
        {
          path: "/oneAdjustmentRes",
          meta: { parentRouter: "/oneAdjustment", alias: "/oneAdjustmentRes" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/oneAdjustment/adjustment.vue"
            ),
        },

        // 单纤维手动微调(加减)
        {
          path: "/blankAdjustment",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/BlankAdjustment/sIndex.vue"
            ),
          meta: { alias: "/dAdjustment-blankAdjustment" },
          beforeEnter: (to, from) => {
            if (
              !["/blankAdjustment-Result", "/"].includes(from.path) ||
              to.path != "/blankAdjustment"
            ) {
              sessionStorage.removeItem("sAdjustmentData1");
            }
          },
        },
        {
          path: "/blankAdjustment-Result",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/BlankAdjustment/sAdjustment.vue"
            ),
          meta: {
            alias: "/dAdjustment-blankAdjustment-Result",
            parentRouter: "/blankAdjustment",
          },
        },

        // 深色微调
        {
          path: "/dAdjustment",
          meta: { alias: "/dAdjustment" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/oneAdjustment/dIndex.vue"
            ),
        },
        {
          path: "/dAdjustmentRes",
          meta: { parentRouter: "/dAdjustment", alias: "/dAdjustmentRes" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/oneAdjustment/dAdjustment.vue"
            ),
        },

        // 单纤维手动微调
        {
          path: "/sAdjustment",
          meta: { alias: "/dAdjustment-sAdjustment" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/oneAdjustment/sIndex.vue"
            ),
        },
        {
          path: "/sAdjustmentRes",
          meta: {
            parentRouter: "/sAdjustment",
            alias: "/dAdjustment-sAdjustmentRes",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/oneAdjustment/sAdjustment.vue"
            ),
        },

        // 配方转换
        {
          path: "/formulaSwitching",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/formulaSwitching/index.vue"
            ),
          meta: { alias: "/formulaSwitching" },
          beforeEnter: (to, from) => {
            if (
              !["/formulaSwitchingRes", "/"].includes(from.path) ||
              to.path != "/formulaSwitching"
            ) {
              console.log(to.path, from.path);
              sessionStorage.removeItem("formulaSwitching");
              sessionStorage.removeItem("formulaSwitchingRes");
            }
          },
        },
        {
          path: "/formulaSwitchingRes",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/formulaSwitching/tableRes.vue"
            ),
          meta: {
            alias: "/formulaSwitchingRes",
            parentRouter: "/formulaSwitching",
          },
        },

        // 混纺配色
        {
          path: "/blending-color-match",
          meta: { alias: "/blend-color-match" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendingColorMatch/index.vue"
            ),
        },
        {
          path: "/blending-color-match-table",
          meta: {
            parentRouter: "/blending-color-match",
            alias: "/blending-color-match",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendingColorMatch/colorTable.vue"
            ),
        },

        // 混纺修色
        {
          path: "/blend-color-trim",
          meta: { alias: "/blend-color-trim" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/blendColorTrim/index.vue"),
          children: [
            {
              path: "",
              meta: { alias: "/blend-color-trim" },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/blendColorTrim/embellish.vue"
                ),
            },
            {
              path: "fast-form",
              meta: {
                parentRouter: "/blend-color-trim",
                alias: "/blend-fast-form",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/blendColorTrim/fastForm.vue"
                ),
            },
            {
              path: "blend-color-trim-form",
              meta: {
                parentRouter: "/blend-color-trim",
                alias: "/blend-color-trim-form",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/blendColorTrim/form.vue"
                ),
            },
          ],
        },
        {
          path: "/blend-color-trim-form-result",
          meta: {
            parentRouter: "/blend-color-trim",
            alias: "/blend-color-trim-form-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/formResult.vue"
            ),
        },
        {
          path: "/blend-color-trim-form-adjustment-result",
          meta: {
            parentRouter: "/blend-color-trim",
            alias: "/blend-color-trim-form-adjustment-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"
            ),
        },
        {
          path: "/blend-color-trim/fast-form/blend-color-form-result",
          meta: {
            parentRouter: "/blend-color-trim",
            alias: "/blend-color-trim/fast-form/blend-color-form-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/BlendFormResult.vue"
            ),
        },

        // 混纺一浴法修色
        {
          path: "/blend-color-oneBathProcess",
          meta: { alias: "/blend-color-oneBathProcess" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/index.vue"
            ),
          children: [
            {
              path: "",
              meta: { alias: "/blend-color-oneBathProcess" },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/list.vue"
                ),
            },
            {
              path: "one-form",
              meta: {
                parentRouter: "/blend-color-oneBathProcess",
                alias: "/blend-one-form",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/form.vue"
                ),
              beforeEnter: (to, from) => {
                if (
                  ![
                    "/blend-color-oneBathProcess-result",
                    "/",
                    "/oneBathProcess-adjustment-result",
                  ].includes(from.path)
                ) {
                  sessionStorage.removeItem("oneBathResult");
                }
              },
            },
            {
              path: "one-fast-form",
              meta: {
                parentRouter: "/blend-color-oneBathProcess",
                alias: "/blend-one-fast-form",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/blendColorTrim/fastForm.vue"
                ),
            },
          ],
        },
        // 混纺一浴法结果
        {
          path: "/blend-color-oneBathProcess-result",
          meta: {
            parentRouter: "/blend-color-oneBathProcess",
            alias: "/blend-color-oneBathProcess-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/oneBathProcess/result.vue"
            ),
        },
        // 混纺一浴法快速修色结果
        {
          path: "/blend-color-oneBathProcess-fast-result",
          meta: {
            parentRouter: "/blend-color-oneBathProcess",
            alias: "/blend-color-oneBathProcess-fast-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/BlendFormResult.vue"
            ),
        },
        {
          path: "/oneBathProcess-adjustment-result",
          meta: {
            parentRouter: "/blend-color-oneBathProcess",
            alias: "/blend-color-oneBathProcess-adjustment-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"
            ),
        },

        // 色库
        // 标样批样
        {
          path: "/standardLot",
          meta: { alias: "/colorLib-standardLot" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/standardLot/index.vue"),
        },
        // 配色色样
        {
          path: "/colorSample",
          meta: { alias: "/colorLib-colorSample" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorSample/singleFabric/index.vue"
            ),
        },
        {
          path: "/colorSample-blend",
          meta: {
            parentRouter: "/colorSample",
            alias: "/colorLib-colorSample-blend",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorSample/multipleFabric/index.vue"
            ),
        },

        // 生产色库 -- 单纤
        {
          path: "/productionColor",
          meta: { alias: "/colorLib-productionColor" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorSample/singleFabric/productionColor.vue"
            ),
        },
        // 生产色库 -- 单纤新建数据
        {
          path: "/productionColorEdit",
          meta: {
            alias: "/colorLib-productionColorEdit",
            parentRouter: "/productionColor",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorSample/singleFabric/colorLib/editColor.vue"
            ),
        },

        // 生产色库 -- 混纺
        {
          path: "/productionColor-blend",
          meta: {
            alias: "/colorLib-productionColor-blend",
            parentRouter: "/productionColor",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorSample/multipleFabric/productionColor.vue"
            ),
        },
        // 生产色库 -- 混纺新建数据
        {
          path: "/productionColorEdit-blend",
          meta: {
            alias: "/colorLib-productionColorEdit-blend",
            parentRouter: "/productionColor",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorSample/multipleFabric/colorLib/editColor.vue"
            ),
        },

        // 自定义色库
        {
          path: "/customColorLot",
          meta: { alias: "/colorLib-customColorLot" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/customColorLot/index.vue"),
          children: [
            {
              path: "",
              meta: {
                parentRouter: "/customColorLot",
                alias: "/colorLib-customColorLot",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/customColorLot/mainPage.vue"
                ),
            },
            {
              path: "newColorLot",
              meta: {
                parentRouter: "/customColorLot",
                alias: "/colorLib-newColorLot",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/customColorLot/newColorLot.vue"
                ),
            },
            {
              path: "newColor",
              meta: {
                parentRouter: "/customColorLot",
                alias: "/colorLib-newColor",
              },
              component: () =>
                import(
                  /* @vite-ignore */ "../views/main/customColorLot/newColor.vue"
                ),
            },
          ],
        },

        // 颜色查询
        {
          path: "/formulaQuery",
          meta: { alias: "/colorLib-formulaQuery" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/formulaQuery/index.vue"),
        },
        // 精明配色
        // 精明配色标识
        {
          path: "/correct-manage",
          meta: { alias: "/correct-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/correctManage/index.vue"),
        },
        // 单纤维精明配色点入录
        {
          path: "/single-correct",
          meta: { alias: "/correct-single-correct" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/singleCorrect/index.vue"),
        },
        // 单纤维详情
        {
          path: "/correct-singleDetail",
          meta: { alias: "/correct-manage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/correctManage/singleDetail.vue"
            ),
        },
        // 混纺精明配色点入录
        {
          path: "/blend-correct",
          meta: { alias: "/correct-blend-correct" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/blendCorrect/index.vue"),
        },
        // 混纺详情
        {
          path: "/correct-blendDetail",
          meta: { alias: "/correct-manage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/correctManage/blendDetail.vue"
            ),
        },

        // 智能柜 仪表台

        {
          // 智能柜仪表台
          path: "/smartCounterDashboard",
          component: () =>
            import(/* @vite-ignore */ "../views/main/smartCounter/index.vue"),
          meta: { alias: "/smartCounter-dashboard" },
        },
        // 新增颜色
        {
          path: "smartCounternewColor",
          meta: {
            parentRouter: "/smartCounterDashboard",
            alias: "/smartCounter-newColor",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/smartCounter/addEdit/index.vue"
            ),
        },
        // 智能柜 cabinet
        {
          // 智能柜
          path: "/smartCounterCabinet",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/smartCounter/cabinet/index.vue"
            ),
          meta: { alias: "/smartCounter-cabinet" },
        },
        {
          // 智能柜管理
          path: "/smartCounterUser",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/smartCounter/user/index.vue"
            ),
          meta: { alias: "/smartCounter-user" },
        },
        // 智能柜物品类型
        {
          path: "/itemType",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/smartCounter/itemtype/index.vue"
            ),
          meta: { alias: "/smartCounter-itemType" },
        },
        // 智能柜 IP 管理
        {
          path: "/smartCounterIp",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/smartCounter/ip/index.vue"
            ),
          meta: { alias: "/smartCounter-ip" },
        },

        // 生产加色记录列表
        {
          path: "/additiveColourList",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/index.vue"
            ),
          meta: { alias: "/product-additiveColourList" },
        },
        // 生产加色记录列表 编辑
        {
          path: "/additiveColourEdit",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/edit.vue"
            ),
          meta: {
            alias: "/product-additiveColourEdit",
            parentRouter: "/additiveColourList",
          },
          beforeEnter: (to, from) => {
            if (
              !["/additiveColourToRes", "/"].includes(from.path) ||
              to.path != "/additiveColourEdit"
            ) {
              sessionStorage.removeItem("BpAddColorRes");
            }
          },
        },
        // 生产加色记录列表 结果
        {
          path: "/additiveColourToRes",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/tableRes.vue"
            ),
          meta: {
            alias: "/product-additiveColourToRes",
            parentRouter: "/additiveColourList",
          },
        },

        // 生产加色
        {
          path: "/additiveColour",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/addColor.vue"
            ),
          meta: { alias: "/product-additiveColour" },
          beforeEnter: (to, from) => {
            if (
              !["/additiveColourRes", "/"].includes(from.path) ||
              to.path != "/additiveColour"
            ) {
              console.log(to.path, from.path);
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/additiveColourRes",
          meta: {
            parentRouter: "/additiveColour",
            alias: "/product-additiveColourRes",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/adjustment.vue"
            ),
        },
        // 生产加色2.0
        {
          path: "/additiveColourTo",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/addColor2.vue"
            ),
          meta: { alias: "/dAdjustment-additiveColourTo" },
          beforeEnter: (to, from) => {
            if (
              !["/additiveColourResTo", "/"].includes(from.path) ||
              to.path != "/additiveColourTo"
            ) {
              console.log(to.path, from.path);
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                delete obj.productListByID;
                obj.depRate = 0;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/additiveColourResTo",
          meta: {
            parentRouter: "/additiveColourTo",
            alias: "/dAdjustment-additiveColourResTo",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/adjustment.vue"
            ),
        },
        // 生产加色3.0
        {
          path: "/additiveColour3",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/addColor3.vue"
            ),
          meta: { alias: "/product-additiveColour3" },
          beforeEnter: (to, from) => {
            if (
              !["/additiveColourRes3", "/"].includes(from.path) ||
              to.path != "/additiveColour3"
            ) {
              console.log(to.path, from.path);
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/additiveColourRes3",
          meta: {
            parentRouter: "/additiveColour3",
            alias: "/product-additiveColourRes3",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/adjustment.vue"
            ),
        },
        // 生产加色4.0
        {
          path: "/additiveColour4",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/addColor4.vue"
            ),
          meta: { alias: "/product-additiveColour4" },
          beforeEnter: (to, from) => {
            if (
              !["/additiveColourRes4", "/"].includes(from.path) ||
              to.path != "/additiveColour4"
            ) {
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                console.log(obj);
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/additiveColourRes4",
          meta: {
            parentRouter: "/additiveColour4",
            alias: "/product-additiveColourRes4",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/adjustment.vue"
            ),
        },

        // 混纺生产加色
        {
          path: "/blendAdditiveColour",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/blendIndex.vue"
            ),
          meta: { alias: "/product-blendAdditiveColour" },
          beforeEnter: (to, from) => {
            if (
              !["/blendAdditiveColourRes", "/"].includes(from.path) ||
              to.path != "/blendAdditiveColour"
            ) {
              console.log(to.path, from.path);
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/blendAdditiveColourRes",
          meta: {
            parentRouter: "/blendAdditiveColour",
            alias: "/product-blendAdditiveColourRes",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/blendAdjustment.vue"
            ),
        },
        // 混纺生产加色4.0
        {
          path: "/blendAdditiveColour4",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/blendIndex4.vue"
            ),
          meta: { alias: "/product-blendAdditiveColour4" },
          beforeEnter: (to, from) => {
            if (
              !["/blendAdditiveColourRes4", "/"].includes(from.path) ||
              to.path != "/blendAdditiveColour4"
            ) {
              console.log(to.path, from.path);
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/blendAdditiveColourRes4",
          meta: {
            parentRouter: "/blendAdditiveColour4",
            alias: "/product-blendAdditiveColourRes4",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/blendAdjustment.vue"
            ),
        },
        // 混纺生产加色3.0
        {
          path: "/blendAdditiveColour3",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/blendIndex3.vue"
            ),
          meta: { alias: "/product-blendAdditiveColour3" },
          beforeEnter: (to, from) => {
            if (
              !["/blendAdditiveColourRes3", "/"].includes(from.path) ||
              to.path != "/blendAdditiveColour3"
            ) {
              console.log(to.path, from.path);
              let obj = JSON.parse(sessionStorage.getItem("addAdjustmentData"));
              if (obj) {
                delete obj.standardSamplingInfo;
                delete obj.dyeSamplingInfo;
                delete obj.products;
                delete obj.productListByID;
                sessionStorage.setItem(
                  "addAdjustmentData",
                  JSON.stringify(obj)
                );
              }
            }
          },
        },
        {
          path: "/blendAdditiveColourRes3",
          meta: {
            parentRouter: "/blendAdditiveColour3",
            alias: "/product-blendAdditiveColourRes3",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/additiveColour/blendAdjustment.vue"
            ),
        },

        // datacolor 连接
        {
          path: "/dataColor",
          component: () =>
            import(/* @vite-ignore */ "../views/main/datacolor/index.vue"),
          meta: { alias: "/dataColor" },
        },
        // 数据可视化
        {
          path: "/dataAnalysis",
          component: () =>
            import(/* @vite-ignore */ "../views/main/dataAnalysis/index.vue"),
          meta: { alias: "/dataAnalysis" },
        },

        {
          path: "/403",
          meta: { alias: "/403" },
          component: () => import(/* @vite-ignore */ "../views/main/403.vue"),
        },
        {
          path: "/connectXM",
          meta: { alias: "/connectXM" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/connectXM/CSIndex.vue"),
        },

        // 微调 修色
        {
          path: "/oneAdjustment-color-trim-result",
          meta: {
            parentRouter: "/oneAdjustment",
            alias: "/oneAdjustment-color-trim-result",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/result.vue"),
        },

        // 自动微调 修色
        {
          path: "/sAdjustment-color-trim-result",
          meta: {
            parentRouter: "/sAdjustment",
            alias: "/sAdjustment-color-trim-result",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/result.vue"),
        },

        // 基础纤维
        {
          path: "/fiber-manage",
          meta: { alias: "/baseData-fiber-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/fiberManage/index.vue"),
        },
        // 系数纤维
        {
          path: "/fiber-coefficient-manage",
          meta: { alias: "/baseData-fiber-coefficient-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/fiberCoeManage/index.vue"),
        },
        // 混纺纤维
        {
          path: "/blend-fiber-manage",
          meta: { alias: "/baseData-blend-manage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendFiberManage/index.vue"
            ),
        },
        {
          path: "/blend-fiber-manage-add",
          meta: {
            parentRouter: "/blend-fiber-manage",
            alias: "/baseData-blend-fiber-manage-add",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/blendFiberManage/add.vue"),
        },
        {
          path: "/blend-fiber-manage-edit",
          meta: {
            parentRouter: "/blend-fiber-manage",
            alias: "/baseData-blend-fiber-manage-edit",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendFiberManage/edit.vue"
            ),
        },
        // 布种工艺
        {
          path: "/fiber-label-manage",
          meta: { alias: "/baseData-fiber-label-manage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/fiberLabelManage/index.vue"
            ),
        },
        // 光源
        {
          path: "/illuminant-manage",
          meta: { alias: "/baseData-illuminant-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/illuminant/index.vue"),
        },
        // 标签
        {
          path: "/tag-manage",
          meta: { alias: "/baseData-tag-manage" },
          component: () =>
            import(/* @vite-ignore*/ "../views/main/tagManage/index.vue"),
        },
        // 染料
        {
          path: "/dye-info",
          meta: { alias: "/baseData-dye-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/dyeInfo/index.vue"),
        },
        // 复合染料
        {
          path: "/rbDye-info",
          meta: { alias: "/baseData-rbDye-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/rbDyeInfo/index.vue"),
        },
        // 组合
        {
          path: "/productMix-manage",
          meta: { alias: "/baseData-productMix-manage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/productMixManage/index.vue"
            ),
        },
        // 用户
        {
          path: "/user-manage",
          meta: { alias: "/baseData-user-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/userManage/index.vue"),
        },
        // 角色
        {
          path: "/role-manage",
          meta: { alias: "/baseData-role-manage" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/roleManage/index.vue"),
        },
        // 查询权限
        {
          path: "/authority-manage",
          meta: { alias: "/baseData-authority-manage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/authorityManage/index.vue"
            ),
        },

        // {
        //   path: "/blend-correct-manage",
        //   meta: { alias: "/blend-correct-manage" },
        //   component: (() =>
        //     import(
        //       /* @vite-ignore */ "../views/main/blendCorrectManage/index.vue"
        //     )
        //   ),
        // },
        // 助剂管理
        // 助剂列表
        {
          path: "/auxiliariesList",
          meta: { alias: "/baseData-auxiliariesList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/auxiliaries/auxiliariesList/index.vue"
            ),
        },
        // 助剂规则
        {
          path: "/auxiliariesRule",
          meta: { alias: "/baseData-auxiliariesRule" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/auxiliaries/auxiliariesRule/index.vue"
            ),
        },
        // 助剂规则 新增 编辑
        {
          path: "/auxiliariesRuleAdd",
          meta: {
            parentRouter: "/auxiliariesRule",
            alias: "/baseData-auxiliariesRuleAdd",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/auxiliaries/auxiliariesRule/add.vue"
            ),
        },
        // 滴液机管理
        {
          path: "/stillicide",
          meta: { alias: "/baseData-stillicide" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/stillicide/index.vue"),
        },

        {
          path: "/home",
          meta: { alias: "/home" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/home/index.vue"),
        },

        // // 生产列表 单纤头缸
        {
          path: "/import-filamentStarFingBath",
          meta: { alias: "/product-import-filamentStarFingBath" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/importStartingBath/filament.vue"
            ),
        },
        {
          path: "/input-singleFiberMultipleSample",
          meta: {
            parentRouter: "/import-filamentStarFingBath",
            alias: "/product-input-singleFiberMultipleSample",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/importStartingBath/duplicateSample/index.vue"
            ),
        },
        // 生产列表 混纺头缸
        {
          path: "/import-blandFilamentStarFingBath",
          meta: { alias: "/product-import-blandFilamentStarFingBath" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/importStartingBath/blendFiber.vue"
            ),
        },
        {
          path: "/input-blendedMultipleSample",
          meta: {
            parentRouter: "/import-blandFilamentStarFingBath",
            alias: "/product-input-blendedMultipleSample",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/importStartingBath/blendDuplicateSample/index.vue"
            ),
        },

        // 出方
        // 单纤维头缸出方
        {
          path: "/export-filamentStarFingBath",
          meta: { alias: "/product-export-filamentStarFingBath" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/filamentBath/colorMatchForm.vue"
            ),
        },
        {
          path: "/export-filamentStarFingBathTable",
          meta: {
            parentRouter: "/export-filamentStarFingBath",
            alias: "/product-export-filamentStarFingBathTable",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/filamentBath/colorTable.vue"
            ),
        },
        // 混纺头缸出方
        {
          path: "/export-blandFilamentStarFingBath",
          meta: { alias: "/product-export-blandFilamentStarFingBath" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/blendBath/colorMatchForm.vue"
            ),
        },
        {
          path: "/export-blandFilamentStarFingBathTable",
          meta: {
            parentRouter: "/export-blandFilamentStarFingBath",
            alias: "/product-export-blandFilamentStarFingBath",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/blendBath/colorTable.vue"
            ),
        },
        // 单纤复样头缸出方
        {
          path: "/export-FilamentStarFingBathRepeated",
          meta: { alias: "/product-export-FilamentStarFingBathRepeated" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/filamentBathRepeated/colorMatchForm.vue"
            ),
        },
        {
          path: "/export-FilamentStarFingBathRepeatedTable",
          meta: {
            parentRouter: "/export-FilamentStarFingBathRepeated",
            alias: "/product-export-FilamentStarFingBathRepeatedTable",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/filamentBathRepeated/colorTable.vue"
            ),
        },
        // 混纺复样头缸出方
        {
          path: "/export-blandFilamentStarFingBathRepeated",
          meta: { alias: "/product-export-blandFilamentStarFingBathRepeated" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/blendBathRepeated/colorMatchForm.vue"
            ),
        },
        {
          path: "/export-blandFilamentStarFingBathRepeatedTable",
          meta: {
            parentRouter: "/export-blandFilamentStarFingBathRepeated",
            alias: "/product-export-blandFilamentStarFingBathRepeatedTable",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/exportScheme/blendBathRepeated/colorTable.vue"
            ),
        },

        //录入生产数据-单纤头缸
        {
          path: "/input-singleFiberHeadCylinder",
          meta: { alias: "/product-input-singleFiberHeadCylinder" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/inputProductionData/singleFiberHeadCylinder/index.vue"
            ),
        },
        //录入生产数据-混纺头缸
        {
          path: "/input-blendedHeadCylinder",
          meta: { alias: "/product-input-blendedHeadCylinder" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/inputProductionData/blendedHeadCylinder/index.vue"
            ),
        },
        //录入生产数据-单纤复样头缸 6/11 改动 取消菜单入口 改为 数据列表按钮跳转
        {
          path: "/input-singleFiberMultipleSampleHeadCylinder",
          meta: {
            alias: "/product-input-singleFiberMultipleSampleHeadCylinder",
            parentRouter: "/manage-singleFiberMultipleSampleHeadCylinder",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/inputProductionData/singleFiberMultipleSampleHeadCylinder/index.vue"
            ),
        },
        //录入生产数据-混纺复样头缸 6/11 改动 取消菜单入口 改为 数据列表按钮跳转
        {
          path: "/input-blendedMultipleSampleHeadCylinder",
          meta: {
            alias: "/product-input-blendedMultipleSampleHeadCylinder",
            parentRouter: "/manage-blendedMultipleSampleHeadCylinder",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/inputProductionData/blendedMultipleSampleHeadCylinder/index.vue"
            ),
        },

        //生产数据管理-单纤头缸
        {
          path: "/manage-singleFiberHeadCylinder",
          meta: { alias: "/product-manage-singleFiberHeadCylinder" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/productionDataManage/singleFiberHeadCylinder/index.vue"
            ),
        },
        //生产数据管理-混纺头缸
        {
          path: "/manage-blendedHeadCylinder",
          meta: { alias: "/product-manage-blendedHeadCylinder" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/productionDataManage/blendedHeadCylinder/index.vue"
            ),
        },

        //生产数据管理-单纤复样头缸
        {
          path: "/manage-singleFiberMultipleSampleHeadCylinder",
          meta: {
            alias: "/product-manage-singleFiberMultipleSampleHeadCylinder",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/productionDataManage/singleFiberMultipleSampleHeadCylinder/index.vue"
            ),
        },

        //生产数据管理-混纺复样头缸
        {
          path: "/manage-blendedMultipleSampleHeadCylinder",
          meta: { alias: "/product-manage-blendedMultipleSampleHeadCylinder" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/productionDataManage/blendedMultipleSampleHeadCylinder/index.vue"
            ),
        },

        //生产2.0
        // 生产订单管理
        {
          path: "/pOrderList",
          meta: { alias: "/product-pOrderList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/index.vue"
            ),
        },
        // 订单管理-颜色详情
        {
          path: "/pColorDetail",
          meta: { alias: "/product-pColorDetail", parentRouter: "/pOrderList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/duplicateSample/index.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/BpAddColorResL", "/"].includes(from.path) ||
              to.path != "/pColorDetail"
            ) {
              sessionStorage.removeItem("BpAddColorRes");
            }
          },
        },
        // 订单管理-颜色详情 -- 混纺
        {
          path: "/BpColorDetail",
          meta: {
            alias: "/product-BpColorDetail",
            parentRouter: "/pOrderList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/index.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/BpAddColorResL", "/"].includes(from.path) ||
              to.path != "/BpColorDetail"
            ) {
              sessionStorage.removeItem("BpAddColorRes");
            }
          },
        },
        // 订单管理-出方
        {
          path: "/pLColorMatch",
          meta: { alias: "/product-pLColorMatch", parentRouter: "/pOrderList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/duplicateSample/colorMatch.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/pcolorMatchResL", "/"].includes(from.path) ||
              to.path != "/pLColorMatch"
            ) {
              sessionStorage.removeItem("pColorMatchRes");
            }
          },
        },
        // 订单管理-出方 -- 混纺
        {
          path: "/bLPcolorMatch",
          meta: {
            alias: "/product-bLPcolorMatch",
            parentRouter: "/pOrderList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/colorMatch.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/pcolorMatchResL", "/"].includes(from.path) ||
              to.path != "/bLPcolorMatch"
            ) {
              sessionStorage.removeItem("pColorMatchRes");
            }
          },
        },
        // 订单管理-出方 -- 结果
        {
          path: "/pcolorMatchResL",
          meta: {
            alias: "/product-pcolorMatchResL",
            parentRouter: "/pOrderList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/tableRes.vue"
            ),
        },
        // 订单管理-加色结果
        {
          path: "/BpAddColorResL",
          meta: {
            alias: "/product-BpAddColorResL",
            parentRouter: "/pOrderList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/tableRes.vue"
            ),
        },

        // 头缸智能出方列表
        {
          path: "/pStartingList",
          meta: { alias: "/product-pStartingList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/startingList.vue"
            ),
        },
        // 出方颜色详情
        {
          path: "/colorDetail",
          meta: {
            alias: "/product-colorDetail",
            parentRouter: "/pStartingList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/duplicateSample/index.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/BpAddColorRes", "/"].includes(from.path) ||
              to.path != "/colorDetail"
            ) {
              sessionStorage.removeItem("BpAddColorRes");
            }
          },
        },
        // 出方颜色详情 -- 混纺
        {
          path: "/BcolorDetail",
          meta: {
            alias: "/product-BcolorDetail",
            parentRouter: "/pStartingList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/index.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/BpAddColorRes", "/"].includes(from.path) ||
              to.path != "/BcolorDetail"
            ) {
              sessionStorage.removeItem("BpAddColorRes");
            }
          },
        },
        // 出方
        {
          path: "/pColorMatch",
          meta: {
            alias: "/product-pColorMatch",
            parentRouter: "/pStartingList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/duplicateSample/colorMatch.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/pcolorMatchRes", "/"].includes(from.path) ||
              to.path != "/pColorMatch"
            ) {
              sessionStorage.removeItem("pColorMatchRes");
            }
          },
        },
        // 出方 -- 混纺
        {
          path: "/bPcolorMatch",
          meta: {
            alias: "/product-bPcolorMatch",
            parentRouter: "/pStartingList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/colorMatch.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/pcolorMatchRes", "/"].includes(from.path) ||
              to.path != "/bPcolorMatch"
            ) {
              sessionStorage.removeItem("pColorMatchRes");
            }
          },
        },
        // 出方 -- 结果
        {
          path: "/pcolorMatchRes",
          meta: {
            alias: "/product-pcolorMatchRes",
            parentRouter: "/pStartingList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/tableRes.vue"
            ),
        },

        // 生产加色列表
        {
          path: "/addColoList",
          meta: { alias: "/product-addColoList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/addColorList.vue"
            ),
        },
        // 加色
        {
          path: "/pAddColor",
          meta: { alias: "/product-pAddColor", parentRouter: "/addColoList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/duplicateSample/addColor.vue"
            ),
        },
        // 混纺 -- 加色
        {
          path: "/BpAddColor",
          meta: { alias: "/product-BpAddColor", parentRouter: "/addColoList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/addColor.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/BpAddColorRes", "/"].includes(from.path) ||
              to.path != "/BpAddColor"
            ) {
              sessionStorage.removeItem("BpAddColorRes");
            }
          },
        },

        // 加色结果
        {
          path: "/BpAddColorRes",
          meta: {
            alias: "/product-BpAddColorRes",
            parentRouter: "/addColoList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/pOrderList/blendDuplicateSample/tableRes.vue"
            ),
        },

        // 生产工艺
        {
          path: "/pTechnology",
          meta: { alias: "/product-pTechnology" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/technology/index.vue"
            ),
        },
        // 生产工艺新增编辑
        {
          path: "/addOrEditPTechnology",
          meta: {
            alias: "/product-addOrEditPTechnology",
            parentRouter: "/pTechnology",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/technology/editOrAdd.vue"
            ),
        },
        // 生产工艺详情
        {
          path: "/detailPTechnology",
          meta: {
            alias: "/product-detailPTechnology",
            parentRouter: "/pTechnology",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/technology/detail.vue"
            ),
        },
        // 散纤出方列表
        {
          path: "/disperseList",
          meta: {
            alias: "/product-disperseList",
            parentRouter: "/disperseList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/dispersePOrderList/index.vue"
            ),
        },
        // 散纤出方编辑
        {
          path: "/disperseEdit",
          meta: {
            alias: "/product-disperseEdit",
            parentRouter: "/disperseList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/dispersePOrderList/edit.vue"
            ),
        },
        // 方案列表
        {
          path: "/schemeList",
          meta: { alias: "/baseData-schemeList" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/schemeList/index.vue"),
        },

        // 批次QC与分色
        {
          path: "/batchQc",
          meta: { alias: "/product-batchQc" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/production/qc/index.vue"),
        },
        // 批次样管理
        {
          path: "/batchList",
          meta: { alias: "/product-batchList", parentRouter: "/batchQc" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/qc/batchList.vue"
            ),
          beforeEnter: (to, from) => {
            if (
              !["/batchListQcRes", "/"].includes(from.path) ||
              to.path != "/batchList"
            ) {
              console.log(to.path, from.path);
              sessionStorage.removeItem("pqcRes");
            }
          },
        },
        // 批次样管理 -- 品控结果
        {
          path: "/batchListQcRes",
          meta: { alias: "/product-batchListQcRes", parentRouter: "/batchQc" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/qc/qcRules.vue"
            ),
        },
        // 分色记录

        {
          path: "/batchColorLog",
          meta: { alias: "/product-batchCOlorLog", parentRouter: "/batchQc" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/qc/colourLog.vue"
            ),
        },
        // 品控记录
        {
          path: "/batchQcLog",
          meta: { alias: "/product-batchCOlorLog", parentRouter: "/batchQc" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/production/qc/qcLog.vue"),
        },

        // 颜色监控列表
        // {
        //   path: "/colorMonitoringList",
        //   meta: { alias: "/product-colorMonitoringList" },
        //   component: () =>
        //     import(
        //       /* @vite-ignore */ "../views/main/production/configuration/index.vue"
        //     ),
        //   children: [
        //     {
        //       path: "",
        //       meta: { alias: "/product-colorMonitoringList" },
        //       component: () =>
        //         import(
        //           /* @vite-ignore */ "../views/main/production/colorMonitoring/index.vue"
        //         ),
        //     },
        //     // 设备管理
        //     {
        //       path: "deviceList",
        //       meta: {
        //         alias: "/baseData-deviceList",
        //         parentRouter: "/colorMonitoringList",
        //       },
        //       component: () =>
        //         import(/* @vite-ignore */ "../views/main/deviceList/index.vue"),
        //     },
        //     // 颜色监控环节配置
        //     {
        //       path: "colorMonitoring",
        //       meta: {
        //         alias: "/baseData-colorMonitoring",
        //         parentRouter: "/colorMonitoringList",
        //       },
        //       component: () =>
        //         import(
        //           /* @vite-ignore */ "../views/main/colorMonitoring/index.vue"
        //         ),
        //     },
        //     // 班组管理
        //     {
        //       path: "teamGroup",
        //       meta: {
        //         alias: "/baseData-teamGroup",
        //         parentRouter: "/colorMonitoringList",
        //       },
        //       component: () =>
        //         import(/* @vite-ignore */ "../views/main/teamGroup/index.vue"),
        //     },
        //   ],
        // },
        {
          path: "/colorMonitoringList",
          meta: { alias: "/product-colorMonitoringList" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/colorMonitoring/index.vue"
            ),
        },
        // 设备管理
        {
          path: "deviceList",
          meta: {
            alias: "/baseData-deviceList",
            // parentRouter: "/colorMonitoringList",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/deviceList/index.vue"),
        },
        // 颜色监控环节配置
        {
          path: "colorMonitoring",
          meta: {
            alias: "/baseData-colorMonitoring",
            // parentRouter: "/colorMonitoringList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/colorMonitoring/index.vue"
            ),
        },
        // 班组管理
        {
          path: "teamGroup",
          meta: {
            alias: "/baseData-teamGroup",
            // parentRouter: "/colorMonitoringList",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/teamGroup/index.vue"),
        },
        // 颜色监控编辑修改
        {
          path: "/colorMonitoringEdit",
          meta: {
            alias: "/product-colorMonitoringEdit",
            parentRouter: "/colorMonitoringList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/colorMonitoring/edit/index.vue"
            ),
        },
        // 颜色监控看板
        {
          path: "/colorMonitoringDataV",
          meta: { alias: "/product-colorMonitoringDataV" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/colorMonitoring/info.vue"
            ),
        },

        // 订单
        // 新建小样订单
        {
          path: "/addSmallSample",
          meta: { alias: "/order-addSmallSample" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/addSmallSample/index.vue"
            ),
        },
        // 小样订单列表
        {
          path: "/smallSampleList",
          meta: {
            alias: "/order-smallSampleList",
            parentRouter: "/smallSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/smallSampleList/index.vue"
            ),
        },
        // 小样订单 配色
        {
          path: "/smallSampleColorMatch",
          meta: {
            alias: "/order-smallSampleColorMatch",
            parentRouter: "/smallSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/smallSampleList/colorMatch/colorMatchForm.vue"
            ),
        },
        // 小样订单 配色结果
        {
          path: "/smallSampleColorTable",
          meta: {
            alias: "/order-smallSampleColorTable",
            parentRouter: "/smallSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/smallSampleList/colorMatch/colorTable.vue"
            ),
        },
        // 小样订单 混纺配色
        {
          path: "/smallSampleBlendColorMatch",
          meta: {
            alias: "/order-smallSampleBlendColorMatch",
            parentRouter: "/smallSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/smallSampleList/blendColorMatch/colorMatchForm.vue"
            ),
        },
        // 小样订单 混纺配色结果
        {
          path: "/smallSampleBlendColorTable",
          meta: {
            alias: "/order-smallSampleBlendColorTable",
            parentRouter: "/smallSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/smallSampleList/blendColorMatch/colorTable.vue"
            ),
        },
        // 小样订单 修色
        {
          path: "/smallSample-color-trim-form",
          meta: {
            alias: "/order-smallSample-color-trim-form",
            parentRouter: "/smallSampleList",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/form.vue"),
        },
        // 小样订单 修色结果
        {
          path: "/smallSample-color-trim-form-result",
          meta: {
            parentRouter: "/smallSampleList",
            alias: "/order-smallSample-color-trim-form-result",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/formResult.vue"),
        },
        // 小样订单  微调结果
        {
          path: "/smallSample-color-trim-adjustment",
          meta: {
            parentRouter: "/smallSampleList",
            alias: "/order-smallSample-color-trim-adjustment",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colorTrim/adjustment.vue"),
        },
        // 小样订单 混纺修色
        {
          path: "/smallSample-blend-color-trim-form",
          meta: {
            parentRouter: "/smallSampleList",
            alias: "/order-smallSample-blend-color-trim-form",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/blendColorTrim/form.vue"),
        },
        // 小样订单 混纺修色结果页
        {
          path: "/smallSample-blend-color-trim-form-result",
          meta: {
            parentRouter: "/smallSampleList",
            alias: "/order-smallSample-blend-color-trim-form-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/formResult.vue"
            ),
        },
        // 小样订单 混纺修色微调
        {
          path: "/smallSample-blend-color-adjustment-result",
          meta: {
            parentRouter: "/smallSampleList",
            alias: "/order-smallSample-blend-color-adjustment-result",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/blendColorTrim/adjustment.vue"
            ),
        },
        // 录入ABC样
        {
          path: "/ABC",
          meta: { alias: "/order-ABC", parentRouter: "/smallSampleList" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/indent/ABC/index.vue"),
        },
        // 录入混纺ABC样
        {
          path: "/blendABC",
          meta: { alias: "/order-blendABC", parentRouter: "/smallSampleList" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/indent/ABC/blendAbc.vue"),
        },

        // 新建复样订单
        {
          path: "/addDuplicateSample",
          meta: { alias: "/order-addDuplicateSample" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/addDuplicateSample/index.vue"
            ),
        },
        // 复样订单列表
        {
          path: "/DuplicateSampleList",
          meta: {
            alias: "/order-smallSampleList",
            parentRouter: "/DuplicateSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/DuplicateSampleList/index.vue"
            ),
        },
        // 复样订单 配色
        {
          path: "/DuplicateSampleColorMatch",
          meta: {
            alias: "/order-DuplicateSampleColorMatch",
            parentRouter: "/DuplicateSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/DuplicateSampleList/colorMatch/colorMatchForm.vue"
            ),
        },
        // 复样订单 配色结果
        {
          path: "/DuplicateSampleColorTable",
          meta: {
            alias: "/order-DuplicateSampleColorTable",
            parentRouter: "/DuplicateSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/DuplicateSampleList/colorMatch/colorTable.vue"
            ),
        },
        // 复样订单 混纺配色
        {
          path: "/DuplicateSampleBlendColorMatch",
          meta: {
            alias: "/order-DuplicateSampleBlendColorMatch",
            parentRouter: "/DuplicateSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/DuplicateSampleList/blendColorMatch/colorMatchForm.vue"
            ),
        },
        // 复样订单 混纺配色结果
        {
          path: "/DuplicateSampleBlendColorTable",
          meta: {
            alias: "/order-DuplicateSampleBlendColorTable",
            parentRouter: "/DuplicateSampleList",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/indent/DuplicateSampleList/blendColorMatch/colorTable.vue"
            ),
        },
        // 复样进入ABC页面
        {
          path: "/dABC",
          meta: { alias: "/order-dABC", parentRouter: "/DuplicateSampleList" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/indent/ABC/dIndex.vue"),
        },
        // 复样进入混纺ABC样
        {
          path: "/dBlendABC",
          meta: {
            alias: "/order-dBlendABC",
            parentRouter: "/DuplicateSampleList",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/indent/ABC/dBlendAbc.vue"),
        },
        // 固色工艺
        {
          path: "/fixedProcess",
          meta: { alias: "/baseData-fixedProcess" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/fixedProcess/index.vue"),
        },

        // 克隆配方
        {
          path: "/cloneForm",
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/clone/index.vue"
            ),
          meta: { alias: "/dAdjustment-cloneForm" },
          beforeEnter: (to, from) => {
            if (
              !["/cloneFormRes", "/"].includes(from.path) ||
              to.path != "/cloneForm"
            ) {
              sessionStorage.removeItem("cloneData");
            }
          },
        },
        {
          path: "/cloneFormRes",
          meta: {
            alias: "/dAdjustment-cloneFormRes",
            parentRouter: "/cloneForm",
          },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/adjustment/clone/tableRes.vue"
            ),
        },
        // 优化配色页面
        // {
        //   path: "/p",
        //   meta: { alias: "/p" },
        //   component: () =>
        //     import(/* @vite-ignore */ "../components/matchColors/index.vue"),
        // },
        //库位管理
        {
          path: "/storageLocationManage",
          meta: { alias: "/baseData-storageLocationManage" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/storageLocationManage/index.vue"
            ),
        },
        //生产数据看板
        {
          path: "/production-dataAnalysis",
          meta: { alias: "/production-dataAnalysis" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/production/dataAnalysis/index.vue"
            ),
        },
        //改色
        {
          path: "/colour-change",
          meta: { alias: "/colour-change-calc" },
          beforeEnter: (to, from) => {
            console.log("===========", to, from);
            if (
              !["/colour-change-result", "/"].includes(from.path) ||
              to.path != "/colour-change"
            ) {
              sessionStorage.removeItem("changeColorPM");
            }
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colourChange/index.vue"),
        },
        //改色结果
        {
          path: "/colour-change-result",
          meta: {
            alias: "/colour-change-calc-result",
            parentRouter: "/colour-change",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/colourChange/result.vue"),
        },
        //染料类型
        {
          // Dye type
          path: "/dyeType",
          meta: { alias: "/dyeType" },
          component: () =>
            import(/* @vite-ignore */ "../views/main/dyeType/index.vue"),
        },
        //仿真色
        {
          // Dye type
          path: "/artificialColors",
          meta: { alias: "/artificialColors" },
          component: () =>
            import(
              /* @vite-ignore */ "../views/main/artificialColors/index.vue"
            ),
          beforeEnter: (to, from) => {
            console.log("===========", to, from);
            if (
              !["/artificialColorsRes", "/"].includes(from.path) ||
              to.path != "/artificialColors"
            ) {
              sessionStorage.removeItem("artificialColors");
            }
          },
        },
        {
          // Dye type
          path: "/artificialColorsRes",
          meta: {
            alias: "/artificialColorsRes",
            parentRouter: "/artificialColors",
          },
          component: () =>
            import(/* @vite-ignore */ "../views/main/artificialColors/res.vue"),
        },

        ...JsdRouter,
        ...BlsRouter,
        ...CCMRouter,
        ...PublicRouter,
        // 入录权限
        // {
        //   path: "/purviewSetting",
        //   meta: { alias: "/purviewSetting" },
        //   component: () =>
        //     import(/* @vite-ignore */ "../views/main/purviewSetting/index.vue"),
        // },
        {
          path: "/",
          redirect: { path: "/home" },
        },
        // {
        //   path: "/p",
        //   meta: { alias: "/p" },
        //   component: () => import(/* @vite-ignore */ "../components/qcPaf.vue"),
        // },
      ],
    },
    {
      path: "/login",
      meta: {
        skip_auth: true,
      },
      component: () =>
        import(/* webpackChunkName: "main" */ "../views/login.vue"),
    },
    {
      path: "/appLogin",
      meta: {
        skip_auth: true,
      },
      component: () =>
        import(/* webpackChunkName: "main" */ "../views/appLogin.vue"),
    },
    {
      path: "/app-pdf",
      meta: {
        skip_auth: true,
      },
      component: () =>
        import(/* webpackChunkName: "main" */ "../views/appPdf.vue"),
    },
    {
      path: "/:pathMatch(.*)*", // 重定向页面地址
      redirect: "/403",
    },
  ],
};
